import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getVendors } from "api/vendor.api";
import { gracefulList } from "lib/queryHelpers";
import { QUERY_KEYS } from "config/queryKeys";
import { DEFAULT_STALE_TIME } from "config/constants";

export const useGetVendors = () => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: QUERY_KEYS.vendors.list(),
    queryFn: gracefulList(getVendors, { vendors: [] }),
    initialData: () => queryClient.getQueryData(QUERY_KEYS.vendors.list()),
    select: (data) => data?.vendors ?? [],
    staleTime: DEFAULT_STALE_TIME,
  });
};